<template>
  <div class="dpt-member">
    <div class="top-wrap">
      <div v-tip class="name">{{ curUser.companyShort }}</div>
      <div class="right">
        <member-search ref="memberSearch" @search="handleSearch"></member-search>
        <base-button
          v-if="!currentCompany.syncDing"
          type="primary"
          @click="openUserDialog()"
          style="margin-left: 10px"
        >
          添加成员
        </base-button>
        <dropdown-menu
          style="margin-left: 10px"
          :menu-list="[{ title: '导出', command: 'exportApp' }]"
          @click="handleCommand"
          placement="bottom-end"
        >
          <base-button icon="el-icon-more" style="padding: 6px 8px;"></base-button>
        </dropdown-menu>
      </div>
    </div>
    <!-- <tabs :tab-list="tabs" :default-active="currentTab" @click="changeTab" class="tabs"></tabs> -->
    <member-table
      ref="memberTable"
      class="table-wrap"
      @edit-user="openUserDialog($event)"
      @switch-user-state="switchUserState"
    ></member-table>
    <edit-dialog ref="editDialog" @change="$emit('change')"></edit-dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import MemberTable from "./MemberTable"
import EditDialog from "./EditDialog"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import MemberSearch from "@/components/UIComponents/MemberSearch"
import { exportCurCompanyUser, switchUserState } from "@/api/user"
import { loadingService } from "@/utils/ui"

export default {
  name: "dpt-member",
  components: {
    BaseButton,
    MemberTable,
    EditDialog,
    DropdownMenu,
    MemberSearch
  },
  inject: ["currentCompany"],
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    }
  },
  data() {
    return {
      tabs: [
        { label: "已激活", value: "Activated" },
        { label: "已停用", value: "Frozen" }
      ],
      userDialogType: "",
      currentTab: "Activated",
      currentUser: {}
    }
  },
  mounted() {
    this.openDialog(this.$route.params?.dialogName)
    this.statusSearch(this.$route.params?.searchKey)
  },
  methods: {
    statusSearch(searchKey) {
      if (searchKey === "status") {
        this.$refs.memberSearch.searchInactive()
      }
    },
    openDialog(dialogName) {
      if (dialogName === "add-member") {
        this.openUserDialog()
      }
    },
    handleSearch(searchInfo, filterKey) {
      this.$refs.memberTable.handleSearch({
        searchKey: filterKey,
        searchInfo: searchInfo || { searchText: "", searchArray: [] }
      })
    },
    changeTab(tab) {
      if (this.currentTab === tab) return
      this.currentTab = tab
    },
    selectDpt(dpt) {
      this.$refs.memberTable.handleSelectDpt(dpt)
    },
    openUserDialog(userInfo) {
      this.$refs.editDialog.open(userInfo)
    },
    switchUserState(user) {
      let isActive = !user?.companyScope?.gone
      this.$confirm(
        isActive
          ? "企业员工停用后,成员将无法进入该企业,是否停用?"
          : "企业员工启用后,成员可以进入该企业,是否启用?",
        isActive ? "停用" : "启用",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        const loadingInstance = loadingService()
        switchUserState(user.id)
          .then(() => {
            this.$message.success("修改成功")
            this.$emit("change")
          })
          .finally(() => loadingInstance.close())
      })
    },
    handleCommand(command) {
      switch (command) {
        case "exportApp": {
          exportCurCompanyUser().then(() => this.$message.success("操作成功"))
          break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dpt-member {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .top-wrap {
    display: flex;
    align-items: center;
    padding: 9px 10px 10px 14px;
    box-sizing: border-box;
    width: 100%;
    .name {
      flex-grow: 0;
      margin-right: 5px;
    }
    .right ::v-deep {
      display: flex;
      margin-left: auto;
      .el-input-group {
        .el-input-group__prepend {
          padding: 0 16px;
          .el-select {
            width: 90px !important;
          }
        }
        > .el-input__inner {
          width: 180px;
        }
        .el-input-group__append {
          padding: 0 14px;
        }
      }
    }
  }
  .tabs {
    margin-left: 14px;
    ::v-deep {
      .tab-title {
        padding: 0 16px 5px;
      }
    }
  }
  .table-wrap {
    flex: 1 1;
    overflow: hidden;
  }
}
</style>
